"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateLocale = void 0;
var i18next_1 = __importDefault(require("i18next"));
var locale_1 = require("date-fns/locale");
// for getting the device's language locale
// 'en' is default deviceLocale
var getDateLocale = function () {
    switch (i18next_1.default.language) {
        case 'fr':
        case 'fr_US':
        case 'fr_FR':
        case 'fr_CA':
            return locale_1.fr;
        case 'es':
        case 'es_US':
        case 'es_MX':
        case 'es_ES':
            return locale_1.es;
        case 'zh':
        case 'zh_CN':
        case 'zh_TW':
            return locale_1.zhCN;
        case 'pt':
        case 'pt_BR':
            return locale_1.ptBR;
        default:
            return locale_1.enUS;
    }
};
exports.dateLocale = getDateLocale();
